import { createSlice } from '@reduxjs/toolkit';

import { staticOrders } from './staticOrders';

const initialState = {
  orders: staticOrders,
  loading: false,
  error: null
};

const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    // Set loading state for all requests
    requestStart: state => {
      state.loading = true;
      state.error = null;
    },
    // Handle failure for all requests
    requestFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    // Fetch orders success
    fetchOrdersSuccess: (state, action) => {
      state.orders = action.payload.data.content;
      state.loading = false;
    },
    // Create new order success
    createOrderSuccess: (state, action) => {
      state.orders.push(action.payload);
      state.loading = false;
    }
  }
});

export const {
  requestStart,
  requestFailure,
  fetchOrdersSuccess,
  createOrderSuccess
} = orderSlice.actions;

export default orderSlice.reducer;
